import * as React from 'react';
import { Prompt } from 'react-router';
import { reduxForm, FieldArray } from 'redux-form';
import { Card } from 'material-ui/Card';
import { get, times, sortBy } from 'lodash';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { compose, withProps, withPropsOnChange } from 'recompose';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { Input, InputField, RemoteAutoCompleteField, RemoteAutoComplete } from '@components/form';

import * as T from '@modules/hr-templates/weeks/_weeksTypes';
import { Link } from 'react-router-dom';
import EntityDetailEnhancer from '@components/hoc/entityDetailEnhancer/EntityDetailEnhancer';
import { getWeekTemplate } from '@modules/hr-templates/weeks/_weeksActions';
import { required } from '@utils/validators';

const linkBack = '/hr/templates/weeks';

const enhance = compose<T.WeeksFormProps, T.WeeksFormProps>(
  EntityDetailEnhancer<T.WeekEnhancerProps<T.Week>, T.Week>({
    getEntity: getWeekTemplate,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [
    { label: 'Týdenní šablony', to: linkBack },
    { label: get(entity, 'name', 'Nová šablona pro týden') }
  ]),
  withPropsOnChange(['entity'], ({ entity }) => ({
    entity: { ...entity, weekDays: sortBy(get(entity, 'weekDays', []), ['order']) }
  })),
  withProps<{}, T.WeeksForm>(({ entity }) => ({
    initialValues: get(entity, 'id')
      ? {
          ...entity
        }
      : {
          weekDays: times(7, Number).map((order: any) => ({ day: null, order }))
        }
  })),
  reduxForm({
    form: 'module-template-days'
  })
);

const renderDays = ({ fields, meta: { error } }) => (
  <>
    {fields.map((weekDay, index) => (
      <div key={index} style={{ width: 110, marginRight: 5 }}>
        <RemoteAutoCompleteField
          id="type"
          caching={true}
          name={`${weekDay}.day.id`}
          label={`Den ${index + 1} *`}
          fullWidth={true}
          component={RemoteAutoComplete}
          url="/metropolis/api/hr/workplan/calendar/day"
          labelFunction={o => get(o, 'label')}
          valueFunction={o => get(o, 'id')}
          validate={[required]}
          arrowstyle={{
            color: '#e1e0e1',
            position: 'absolute',
            right: 0,
            top: 32
          }}
        />
        <InputField component={Input} name={`${weekDay}.order`} label="Pořadí" disabled={true} />
      </div>
    ))}
    {error && <div className="error">{error}</div>}
  </>
);

const View: React.SFC<T.WeeksFormProps> = props => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <Grid fluid={true}>
          <Row>
            <Col className="grid-system-margin" />
          </Row>
          <Row>
            <Col md={6} xl={4}>
              <Row>
                <Col md={12}>
                  <h4>Základní údaje</h4>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={4} xl={2}>
              <Row>
                <Col md={12}>
                  <InputField component={Input} name="label" label="Název *" validate={[required]} />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={12} lg={10} xl={8}>
              <Row>
                <Col md={12}>
                  <div style={{ display: 'flex' }}>
                    <FieldArray<any> name="weekDays" component={renderDays} />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} containerElement={<Link to={linkBack} />} />
      </Card>
    </form>
  </div>
);

export const WeeksForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/hr-templates/weeks/WeeksForm.tsx